import { DatePipe } from "@angular/common";
import { Component, OnInit, HostListener } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { BnLoadingService, EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Subscription } from "rxjs";
import { ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO } from "src/app/constantes/permissao.constants";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { JanelaAtualizacaoInformacoes, TIPOS_JANELA } from "src/app/model/janelas-atualizacao-informacoes.model";
import { PermissaoService } from "src/app/shared/permissao.service";
import { JanelasAtualizacaoInformacoesService } from "../janelas-atualizacao-informacoes.service";
import { Dominio } from 'src/app/model/dominio-operacao.model';
import { ModalidadeGarantiaService } from "../../modalidade_garantia/modalidade-garantia.service";

@Component({
    selector: 'app-janelas-atualizacao-info-pesquisa',
    templateUrl: './janelas-atualizacao-informacoes-pesquisa.html',
    standalone: false
})
export class JanelasAtualizacaoInformacoesPesquisaComponent implements OnInit {

    public pesquisado: boolean = false;
    public podeIncluirNovaJanela: boolean = true;

    public pesquisaForm: UntypedFormGroup;
    private opcoesPaginacao: number[];

    public janelas: JanelaAtualizacaoInformacoes[] = [];
    public agentesFinanceiros: AgenteFinanceiro[] = [];

    private atributosPaginacaoComponenteListagem: EntityPagedResult<JanelaAtualizacaoInformacoes>;

    public tiposJanela = TIPOS_JANELA;

    public dadosDominio: Dominio;

    private subscricoes: Subscription[] = [];

    constructor(
        private formBuilder: UntypedFormBuilder,
        private activatedRoute: ActivatedRoute,
        private bnLoadingService: BnLoadingService,
        private permissaoService: PermissaoService,
        private janelasAtualizacaoInfoService: JanelasAtualizacaoInformacoesService,
        private datePipe: DatePipe,
    ) {
        this.pesquisaForm = this.formBuilder.group({
            dataAbertura: null,
            dataFechamento: null,
            tipoJanela: null,
            modalidadeGarantia: null,
        });

        this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
        this.dadosDominio = this.activatedRoute.snapshot.data['dominios'];
    }

    @HostListener('window:keydown.enter', ['$event'])
    keyEvent(event: KeyboardEvent) {
      this.buscar();
    }
  

    public ngOnInit(): void {

        this.setPaginacao();
        this.checaPermissoes();
    }

    public ngOnDestroy(): void {
        this.subscricoes.forEach(s => s.unsubscribe());
    }

    private setPaginacao(): void {
        this.opcoesPaginacao = [10, 15, 20];
        this.atributosPaginacaoComponenteListagem = {
            page: 1,
            pageSize: this.opcoesPaginacao[0],
            pages: undefined,
            count: undefined,
            list: undefined
        };
    }

    private checaPermissoes(): void {
        this.subscricoes.push(this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
            this.podeIncluirNovaJanela = resp && resp[ROLE_GESTOR_ENVIO];
            this.construirFormulario();
        }));

    }

    private construirFormulario(): void {

        const valoresPesquisaForm = JSON?.parse(sessionStorage.getItem('valoresPesquisaJanelaAtualizacaoInfoForm'));

        if (valoresPesquisaForm) {
            this.pesquisaForm = this.formBuilder.group({
                dataAbertura: valoresPesquisaForm.dataAbertura,
                dataFechamento: valoresPesquisaForm.dataFechamento,
                tipoJanela: valoresPesquisaForm.tipoJanela,
                modalidadeGarantia: valoresPesquisaForm.modalidadeGarantia,
            });
        }

        this.subscricoes.push(this.pesquisaForm.valueChanges.pipe().subscribe(novosValores => {
            sessionStorage.setItem('valoresPesquisaJanelaAtualizacaoInfoForm', JSON.stringify(novosValores));
        }));
    }

    public mudancaPagina(novaPagina: EntityPagedResult<JanelaAtualizacaoInformacoes>): void {
        this.atributosPaginacaoComponenteListagem = novaPagina;
        this.buscar();
    }

    public limpaFormulario(): void {
        this.pesquisado = false;
        this.pesquisaForm.reset();
        this.janelas = [];
    }

    private buscar(): void {

        this.bnLoadingService.bloqueiaTela();
        const dadosPreenchidos = this.tratarInformacoesPreenchidas();
        dadosPreenchidos.pagina = this.atributosPaginacaoComponenteListagem.page;
        dadosPreenchidos.limite = this.atributosPaginacaoComponenteListagem.pageSize;

        this.subscricoes.push(this.janelasAtualizacaoInfoService
            .getJanelasAtualizacaoInformacao(dadosPreenchidos)
            .subscribe(response => {
                console.log(response);
                this.pesquisado = true;
                this.janelas = response.resultados;
                this.bnLoadingService.liberaTela();
            }));
    }

    private tratarInformacoesPreenchidas(): any {

        let dadosPreenchidos: any = {};
        const form = this.pesquisaForm.value;

        if (form.dataAbertura)
            dadosPreenchidos.dataAbertura = this.datePipe.transform(form.dataAbertura, 'yyyyMMdd');
        if (form.dataFechamento)
            dadosPreenchidos.dataFechamento = this.datePipe.transform(form.dataFechamento, 'yyyyMMdd');
        if (form.tipoJanela)
            dadosPreenchidos.tipoJanela = form.tipoJanela;
        if (form.modalidadeGarantia)
            dadosPreenchidos.modalidadeGarantia = form.modalidadeGarantia;

        return dadosPreenchidos;
    }

}
